'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExclamationMarkTriangle;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function ExclamationMarkTriangle(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-exclamation-mark-triangle ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M15.8436085,13.1045991 C15.9918501,13.4010827 16.0381758,13.7021986 15.9825851,14.0079472 C15.9269945,14.3136958 15.7787529,14.5731186 15.5378599,14.7862163 C15.2969669,14.9993139 15.0097487,15.1058625 14.6762048,15.1058625 L1.33444862,15.1058625 C1.00090471,15.1058625 0.713686491,14.9993139 0.47279353,14.7862163 C0.231900568,14.5731186 0.0836589738,14.3136958 0.028068323,14.0079472 C-0.0275223279,13.7021986 0.0188033559,13.4010827 0.16704495,13.1045991 L6.83792305,1.54174373 C7.004695,1.24526011 7.24095527,1.04606056 7.54670385,0.94414423 C7.85245243,0.842227896 8.15820101,0.842227896 8.46394959,0.94414423 C8.76969816,1.04606056 9.00595843,1.24526011 9.17273038,1.54174373 L15.8436085,13.1045991 Z M8.00532672,10.7142011 C7.65325245,10.7142011 7.35213657,10.8392801 7.10197864,11.089438 C6.85182071,11.3395959 6.72674175,11.6407118 6.72674175,11.9927861 C6.72674175,12.3448603 6.85182071,12.6459762 7.10197864,12.8961342 C7.35213657,13.1462921 7.65325245,13.2713711 8.00532672,13.2713711 C8.35740098,13.2713711 8.65851686,13.1462921 8.90867479,12.8961342 C9.15883272,12.6459762 9.28391168,12.3448603 9.28391168,11.9927861 C9.28391168,11.6407118 9.15883272,11.3395959 8.90867479,11.089438 C8.65851686,10.8392801 8.35740098,10.7142011 8.00532672,10.7142011 Z M6.7823324,6.12797242 L7.004695,9.90813668 C7.004695,9.98225768 7.03712302,10.051746 7.10197864,10.1166016 C7.16683426,10.1814572 7.24558796,10.2138853 7.33823891,10.2138853 L8.67241453,10.2138853 C8.76506547,10.2138853 8.84381917,10.1814572 8.90867479,10.1166016 C8.97353041,10.051746 9.00595843,9.98225768 9.00595843,9.90813668 L9.22832103,6.12797242 C9.22832103,6.01679112 9.19589301,5.92877245 9.1310374,5.86391683 C9.06618178,5.79906121 8.98742807,5.76663319 8.89477713,5.76663319 L7.1158763,5.76663319 C7.02322536,5.76663319 6.94447165,5.79906121 6.87961604,5.86391683 C6.81476042,5.92877245 6.7823324,6.01679112 6.7823324,6.12797242 Z' })
  );
}

ExclamationMarkTriangle.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/ExclamationMarkTriangle/ExclamationMarkTriangle.js
// module id = 217
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16